/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BuilderFormSchemaFactory, FormRootSchema } from '@gh/builder-shared';
import { FormState, FormStateSchema } from '@gh/common-shared';
import { FormMode, getControl, S3UploadItem, UploadContext, UploadSlot } from '@gh/core-ui';
import { UserProfileSignature } from '../../resources';

@Injectable()
export class UserProfileSignatureFormService extends FormState<UserProfileSignature> {
  pictureSlot: UploadSlot;

  constructor(private uploadContext: UploadContext, schemaFactory: BuilderFormSchemaFactory) {
    super(schemaFactory);

    this.pictureSlot = uploadContext.createUploadSlot({
      entryPoint: 'SIGNATURE',
    });
  }

  build(signature: UserProfileSignature): void {
    this.initSchema(signature);

    this.pictureSlot.setControl(getControl(this.group, 'picture'));
  }

  protected buildSchema(_: UserProfileSignature, { root }: FormStateSchema): FormRootSchema {
    return root({
      mode: FormMode.EditMode,
      enabled: true,
      children: {
        picture: { asyncValidators: [this.pictureSlot.formValidator()] },
      },
    });
  }
}
